import React from "react";

import { AuthenticationRouter } from "./pages/authentication/Router";
import { AuthProtectedRoute } from "common/components/AuthProtectedRoute";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Documents } from "pages/user/Documents";
import { IDNowStatus } from "pages/idnow-status/IDNowStatus";
import { PurchaseSharesForm } from "./pages/investment/purchase-shares/PurchaseSharesForm";
import { KnowYourCustomerForm } from "pages/kyc/KnowYourCustomerForm";
import { PersonalData } from "pages/user/PersonalData";
import { PropertyDetail, BrowseProperties, Dashboard } from "pages";
import { useCurrentUser } from "common/store/user/hooks/useCurrentUser";

import {
  UserInfoProtectedRoute,
  ProtectionType,
} from "components/UserInfoProtectedRoute";

export const AppRouter = () => {
  useCurrentUser();

  return (
    <Router>
      <Switch>
        <Route path="/authentication">
          <AuthenticationRouter />
        </Route>
        <UserInfoProtectedRoute
          path="/shares/:id"
          component={PurchaseSharesForm}
          reverseLogic={false}
          protection={ProtectionType.UserVerified}
        />
        <AuthProtectedRoute path="/dashboard" component={Dashboard} />
        <UserInfoProtectedRoute
          path="/personal-data"
          component={PersonalData}
          reverseLogic={false}
        />
        <AuthProtectedRoute path="/documents" component={Documents} />
        <AuthProtectedRoute path="/kyc" component={KnowYourCustomerForm} />
        <AuthProtectedRoute path="/offerings" component={BrowseProperties} />
        <AuthProtectedRoute path="/offering/:id" component={PropertyDetail} />
        <AuthProtectedRoute path="/idnowstatus" component={IDNowStatus} />
        <Route path="/">
          <AuthenticationRouter />
        </Route>
      </Switch>
    </Router>
  );
};
